<template>
  <div class="projecten-wrapper">
    <div class="bg-secondary knd-paragraph">
      <div class="knd-wrapper-text ta-center">
        <h3 class="ta-center">De projecten van {{companyName}}</h3>
        <!-- <div v-html="judgement_projects"></div> -->
        <p>{{companyName}} onderbouwt de CO2-compensatie claims met de volgende projecten.</p>
      </div>

      <div class="projects-wrapper knd-wrapper-md mb-lg">

        <div class="column column-projects">
          <div class="column-header">
            Aantal Projecten
          </div>
          <div class="column-body">
            <div>
              <div class='projects-total'>{{ projects.length }}</div>
            </div>
          </div>
        </div>

        <div class="column column-types">
          <div class="column-header">
            Type Project
          </div>
          <div class="column-body">
              <div class="projects-type" 
              v-for="(value, key) in types"
              :key="'type' + value">
                <div class="projects-type-icon">
                  <img :src="getIcon(key)" />
                </div>
                <div>
                <div class="projects-type-value">
                  {{ value.length }}x
                </div>
                <div class="projects-type-label">
                  {{key}}
                </div>
              </div>
              </div>
          </div>
        </div>


        <div class="column">
          <div class="column-header">
            Soort project
          </div>
          <div class="column-body">
                <div 
                  class="projects-kind" 
                  v-for="(value, key) in kind" 
                  :key="'kind' + key"
                  :class="'kind-' + key.toLowerCase()"
                >
                  <div class="projects-kind-value">
                    {{ value.length }} {{value.length === 1 ? 'project' : 'projecten'}}
                  </div>
                  <div class="projects-kind-label">
                    {{key}}
                  </div>
              </div>
          </div>
        </div>
      </div>

      <div class="knd-wrapper-text">
        <ProjectsCollapse :projects="projects" />
      </div>
    </div>
</div>
</template>

<script setup>
	import { ref, computed } from 'vue'
	import { mapGetters, useStore } from 'vuex';
	const store = useStore()
	
  import ProjectsCollapse from './projects.vue';

  const companyName = computed(() => store.getters.selectedCompanyName);
  const projects = computed(() => store.getters.selectedProjects);

  function getIcon(key) {
    key = key.replace(" ", "-");

    try {
      return require(`@/assets/icons/${ key.toLowerCase()}.svg`);
    } catch {
      return require(`@/assets/icons/placeholder.svg`);
    }
  }

  function groupByKey(list, key) {
   return list
     .reduce((hash, obj) => {
       if(obj[key] === undefined) return hash; 
       return Object.assign(hash, { [obj[key]]:( hash[obj[key]] || [] ).concat(obj)})
     }, {})
}

  const types = computed(() => groupByKey(projects.value, 'type'));
  const kind = computed(() => groupByKey(projects.value, 'soort'));

</script>

<style lang="scss">
  .projects-wrapper {
    background: var(--off-white);
    color: var(--moss);
    padding: 2rem;

    display: flex;
    flex-direction: column;
    margin-left: 2rem !important;
    margin-right: 2rem !important;

    @include md { 
      flex-direction: row;
      margin-left: auto !important;
      margin-right: auto !important;
    }

    & > * {
        flex: 1 100%;
    }

    .column {
        border-bottom: 2px solid var(--moss);

      @include md { 
        border-right: 2px solid var(--moss);
        border-bottom: none;
      }

      &:last-of-type {
        border-right: none;
        border-bottom: none;
      }
    }

    .column-header {
      font-family: var(--font-header);
      font-size: 2.8rem;
      padding: 2rem;
      text-align: center;

      @include md { 
        border-bottom: 2px solid var(--moss);
      }

    }

    .column-projects {
      display: flex;
      flex-direction: column;

      .column-body {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
        padding-bottom: 2rem;

        @include md { 
          padding-bottom: 0;
        }
    }
  
      .projects-total {
        border-radius: 100%;
        background: var(--moss);
        color: var(--off-white);
        display: inline-block;
        min-width: 3em;
        padding: 1em;
        border-radius: 50%;
        font-size: 30px;
        text-align: center;        
        line-height: 1;
      }
    }

    .column-types {
      .column-body {
        padding: 2rem;
      }
    }

    .projects-type {
      display: flex;
      margin-bottom: 2rem;

      .projects-type-icon {
        width: 60px;
        margin-right: 1rem;
      }
    }

    .projects-kind {
      text-align: center;
      padding: 1rem;

      &.kind-vermindering {
        color: var(--off-white);
        background: var(--verminderen);
      }
  
      &.kind-vermijding {
        background: var(--vermijden);
      }
  
      &.kind-verwijdering {
        background: var(--verwijderen);
      }
    }


  }
</style>